import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ClientContactMainWrapper = styled.div`
  .header-contact {
    ${responsive.MOBILE`
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%; 
    `}
  }
  .semi-header {
    display: flex;
    padding: 16px 28px;
    justify-content: flex-end;
  }
`;
